import { FormSlugs } from "../../models";

export const hideSignatureForSlugs: (string | undefined)[] = [
    FormSlugs.DED,
    FormSlugs.MedicalRecordsRequest,
    FormSlugs.TIF,
    FormSlugs.TissueRecipientInfo,
    FormSlugs.ImportTissueDocumentation,
];

export const hideSignature = (formSlug: string | undefined) => hideSignatureForSlugs.includes(formSlug);

export const hideSignatureHeaderForSlugs: (string | undefined)[] = [
    FormSlugs.EventReport,
    FormSlugs.QaAudit,
    FormSlugs.TissueRecipientInfo,
    FormSlugs.PlasmaDilutionWorksheet,
];

export const hideSignatureHeader = (formSlug: string | undefined) => hideSignatureHeaderForSlugs.includes(formSlug);

export const externalSignatureSlugs: (string | undefined)[] = [];

export const isExternalSignature = (formSlug: string | undefined) => externalSignatureSlugs.includes(formSlug);

export const hideNewFormButtonForSlugs: (string | undefined)[] = [
    FormSlugs.Recovery,
    FormSlugs.DED,
    FormSlugs.DonorOmar,
    FormSlugs.TIF,
    FormSlugs.TissueOmarImport,
    FormSlugs.TissueOmarProcessReturn,
    FormSlugs.TissueOmarReturned,
    FormSlugs.TissueOmarSatelliteTransfer,
];

export const hideNewFormButton = (formSlug: string | undefined) => hideNewFormButtonForSlugs.includes(formSlug);

export const transformTextareasOnDownloadForSlugs: (string | undefined)[] = [
    FormSlugs.TissueRecipientInfo,
    FormSlugs.MedicalRecordsRequest,
];

export const transformTextareasOnDownload = (formSlug: string | undefined) =>
    transformTextareasOnDownloadForSlugs.includes(formSlug);

export const requireAttachmentsForSlugs: (string | undefined)[] = [FormSlugs.EventReport];

export const requireAttachments = (formSlug: string | undefined) => requireAttachmentsForSlugs.includes(formSlug);
